import {GeoJSON} from "ol/format";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {getLayerNamePrefix, removeLoaderByBookmarkPresentationID} from "@/helpers/ol/ol-layer-helper.js";
import {getWfsStyleFunction} from "@/modules/ol/service/ol-service-wfs.js";
import {bbox as bboxStrategy} from "ol/loadingstrategy.js";
import {getViewProjectionOgcName} from "@/helpers/ol/ol-projection-helper.js";

export function addServiceOgcApi(map, service) {
    let serviceUrl = service.Url + "/collections/" + service.Layer + "/items?f=json";


    //TODO limit dynamisch maken

    const vectorSource = new VectorSource({
        format: new GeoJSON(),
        strategy: bboxStrategy,
        url: function (extent) {
            console.log(extent)
            return serviceUrl + '&limit=1000&bbox-crs=' + getViewProjectionOgcName() +'&bbox=' + extent.join(',');
        }
    });

    removeLoaderByBookmarkPresentationID(service.id)

    const vectorLayer = new VectorLayer({
        altitudeMode: 'clampToGround',
        name: getLayerNamePrefix() + service.id,
        zIndex: service.zIndex,
        minResolution: service.MinResolution / 1000,
        maxResolution: service.MaxResolution / 1000,
        opacity: service.Opacity / 10,
        style: getWfsStyleFunction(service),
        source: vectorSource,
    });

    map.getLayers().push(vectorLayer);

    return vectorLayer;
}